import { createContext, useContext } from 'react';

export type BannerTypeContextProviderValues = {
    bannerType: string;
    setBannerType: (title: string) => void;
};

const defaultContext: BannerTypeContextProviderValues = {
    bannerType: '',
    setBannerType: () => {},
};

export const BannerTypeContext = createContext<BannerTypeContextProviderValues>(defaultContext);

export const useBannerTypeContext = () => useContext(BannerTypeContext);
